import {apiService} from "@/services/ApiService";
import {AxiosResponse} from "axios";

export class ContactFormService {
  public async sendContactFormData(payload: IContactRequest) {
    const {captchaToken, ...payloadToSend} = payload;
    const response: Promise<AxiosResponse> = apiService.postWithCaptcha(
      "SelfScheduling/ContactRequest",
      payloadToSend,
      captchaToken
    );

    return response;
  }
}

export const contactFormService = new ContactFormService();
